import axios from '@/plugins/axios'

const getTimezones = () => axios.get('timezones')
const getCountries = (params) => axios.get('countries', { params })
const getLanguages = () => axios.get('text-to-speech')

const getMaintenanceMode = () => axios.get('application-maintenance-mode')

export {
    getTimezones, getCountries, getLanguages, getMaintenanceMode,
}
